import {
  MqttProvider as BaseMqttProvider,
  type MqttProviderProps,
} from '@unifyapps/network/mqttClient';
import useIsPrintPreview from '../hooks/useIsPrintPreview';
import { useGetUserContext } from '../no-code/hooks/useGetUserContext';

export function MqttProvider(props: MqttProviderProps) {
  const isPrintPreview = useIsPrintPreview();
  const { userContext } = useGetUserContext();

  if (isPrintPreview) {
    return props.children;
  }

  return <BaseMqttProvider {...props} username={userContext?.id ?? ''} />;
}
